export enum ExpandedLinkVariant {
  /** These stack so they have to be the same width */
  sideNav = 'sideNav',
  /** These are rendered in a row, so can have their width sized by the content */
  action = 'action',
  /** These have different styles and are first used in the school settings header links section. */
  headerNav = 'headerNav'
}